import * as Sentry from '@sentry/react';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';
import {getIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';
import {IVIntent, QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

export const useIVCompleted = () => {
  const queryClient = useQueryClient();
  const {mutate: finishIVByQr, isPending} = useMutation<
    IVIntent,
    Error,
    {
      iv_intent_id: string;
      continue_on_mobile: boolean;
    }
  >({
    mutationFn: payload => API.identityVerification.finishIVByQr(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY_CACHE_KEYS.guestGroup]});
      void queryClient.invalidateQueries({queryKey: [QUERY_CACHE_KEYS.summary]});
    },
    onError: error => {
      Sentry.captureException(error);
    },
  });

  const returnToDesktop = useCallback(() => {
    const intentId = getIVIntentRemoteSession();
    if (intentId) {
      finishIVByQr({
        iv_intent_id: intentId,
        continue_on_mobile: false,
      });
    }
  }, [finishIVByQr]);

  const continueOnPhone = useCallback(() => {
    const intentId = getIVIntentRemoteSession();
    if (intentId) {
      finishIVByQr({
        iv_intent_id: intentId,
        continue_on_mobile: true,
      });
    }
  }, [finishIVByQr]);

  return {
    isLoading: isPending,
    returnToDesktop,
    continueOnPhone,
  };
};
